'use strict';

const _ = require('underscore');
const Key = require('common/domain/value/key');
const AnnouncementModel = require('feedback/domain/entity/announcement');
const AnnouncementCategory = require('../value/announcement-category');

class ReleaseNoteModel extends AnnouncementModel {
    static getCategoryName() {
        return AnnouncementCategory.getReleaseNoteName();
    }

    getCategoryName() {
        return ReleaseNoteModel.getCategoryName();
    }

    getIdeaKeys() {
        return _.map(this.get('ideaKeys'), json => {
            return new Key(json);
        });
    }
}

module.exports = ReleaseNoteModel;



// WEBPACK FOOTER //
// ./feedback/domain/entity/release-note.js